import { FC, SyntheticEvent, useState } from 'react';
import { Divider, IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  AccountCircle as AccountCircleIcon,
  Face as FaceIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  VpnKeyRounded,
  SwitchAccount as SessionsIcon,
} from '@mui/icons-material';

import { useAppDispatch } from '/store';
import { logout } from '/store/toolkits/auth/actions';
import { keysManagerPath } from '/component/ApiKeysManager/ApiKeysManagerRoutes';

import { StyledLink, StyledLinkItemText } from './styles';

const profileUrl = '/user-profile';
const sessionsUrl = '/sessions';

export const Profile: FC = () => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>();

  const handleOpen = (event: SyntheticEvent) => {
    const target = event.currentTarget as HTMLButtonElement;
    setAnchorEl(target);
  };

  const handleClose = (event?: unknown) => {
    if ((event as SyntheticEvent & { metaKey?: boolean })?.metaKey) {
      return;
    }
    setAnchorEl(undefined);
  };

  const onLogOut = () => {
    handleClose();
    dispatch(logout());
  };

  return (
    <>
      <IconButton
        color='inherit'
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup='true'
        aria-label='Profile section'
        onClick={handleOpen}
        size='large'
      >
        <FaceIcon />
      </IconButton>
      <Menu id='simple-menu' anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <StyledLink to={profileUrl} onClick={handleClose}>
          <MenuItem>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <StyledLinkItemText primary='Profile' />
          </MenuItem>
        </StyledLink>

        <StyledLink to={keysManagerPath} onClick={handleClose}>
          <MenuItem>
            <ListItemIcon>
              <VpnKeyRounded />
            </ListItemIcon>
            <StyledLinkItemText primary='API Keys' />
          </MenuItem>
        </StyledLink>
        <Divider />

        <StyledLink to={sessionsUrl} onClick={handleClose}>
          <MenuItem>
            <ListItemIcon>
              <SessionsIcon />
            </ListItemIcon>
            <StyledLinkItemText primary='Sessions' />
          </MenuItem>
        </StyledLink>
        <Divider />

        <MenuItem onClick={onLogOut}>
          <ListItemIcon>
            <PowerSettingsNewIcon />
          </ListItemIcon>
          <StyledLinkItemText primary='Log out' />
        </MenuItem>
      </Menu>
    </>
  );
};
